import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy path for the New Wealth stub — now lives at /people.
export const Route = createFileRoute('/checks')({
  beforeLoad: () => {
    throw redirect({ to: '/people' });
  },
});
